import * as React from 'react';
import { cn } from '@/hen-ui/utils';
import { browVariants, type BrowVariantProps } from './brow.variants';

export interface BrowProps
  extends Omit<React.HTMLAttributes<HTMLElement>, 'color'>,
    BrowVariantProps {
  children: string;
}

export const Brow = React.forwardRef<HTMLElement, BrowProps>(
  ({ className, color, align, children, ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(browVariants({ color, align }), className)}
        {...props}
      >
        {children}
      </span>
    );
  },
);

Brow.displayName = 'Brow';
